import { formatNumberCoords } from '../utils/functions';
const tameside = [
  53.492268979912275,
  -2.163189016274094,
  53.48366889221827,
  -2.170055471352219,
  53.47547573127901,
  -2.163189016274094,
  53.46914089497386,
  -2.146366201332688,
  53.458512594458654,
  -2.146366201332688,
  53.455241812808076,
  -2.157352529457688,
  53.44072467960446,
  -2.1415596827780004,
  53.43213474401267,
  -2.0952111110006566,
  53.43786156066894,
  -2.0897179469381566,
  53.4343846568787,
  -2.0787316188131566,
  53.42865737166389,
  -2.0811348780905004,
  53.42968015776901,
  -2.046115957192063,
  53.42742999585203,
  -2.035472951820969,
  53.43908863526462,
  -2.014873586586594,
  53.43540730517073,
  -2.003887258461594,
  53.442360660949824,
  -2.0042305812155004,
  53.45442407803027,
  -1.9863777980123754,
  53.46055670505627,
  -1.9877510890280004,
  53.46362268643805,
  -1.9795113429342504,
  53.469549622625436,
  -1.9863777980123754,
  53.48242252902318,
  -1.986034475258469,
  53.48712118845873,
  -1.9726448878561254,
  53.49508729114006,
  -1.9698983058248754,
  53.502235083727484,
  -1.9716149195944066,
  53.50936153261752,
  -1.963341309322555,
  53.520385338129245,
  -1.9914937751428674,
  53.51875236272094,
  -2.0053983466760705,
  53.521405915797125,
  -2.01689965893193,
  53.52610025640454,
  -2.0148397224084924,
  53.5291615026186,
  -2.03063256908818,
  53.52895742642129,
  -2.05260522533818,
  53.52365110012372,
  -2.05260522533818,
  53.52120180223044,
  -2.09105737377568,
  53.509800505223176,
  -2.101030665728012,
  53.50629885543659,
  -2.119896485103805,
  53.50119390166353,
  -2.12126977611943,
  53.498365499647996,
  -2.1305564225639495,
  53.49220768981213,
  -2.1356893317834924,
  53.49387233204749,
  -2.1556189835991058,
];

export const tamesideAreaCoords = formatNumberCoords(tameside);
